module.exports = "<div class=\"main_c_b_title\">\n    <h2>Job<br class=\"title_br\" />Search</h2>\n    <h6>In Construction World</h6>\n</div>"